import { render, staticRenderFns } from "./MTabMenu.vue?vue&type=template&id=7a0b1e7c&scoped=true&"
import script from "./MTabMenu.vue?vue&type=script&lang=js&"
export * from "./MTabMenu.vue?vue&type=script&lang=js&"
import style0 from "./MTabMenu.vue?vue&type=style&index=0&id=7a0b1e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0b1e7c",
  null
  
)

export default component.exports